/**
 * Simple Pendo Analytics Service
 */

// Extend the Window interface to include Pendo
declare global {
    interface Window {
        pendo: {
            initialize: (options?: any) => void;
            identify: (visitorId: string, accountId?: string, visitorData?: any, accountData?: any) => void;
            pageLoad: (options?: any) => void;
            isReady: () => boolean;
        };
    }
}

class PendoService {
    /**
     * Check if Pendo is available and ready
     */
    private isPendoReady(): boolean {
        return (
            typeof window !== 'undefined' &&
            window.pendo &&
            typeof window.pendo.isReady === 'function' &&
            window.pendo.isReady()
        );
    }

    /**
     * Initialize Pendo
     */
    initialize(options?: any): void {
        if (typeof window === 'undefined' || !window.pendo) return;

        try {
            window.pendo.initialize(options);
        } catch (error) {
            console.error('Pendo initialization failed:', error);
        }
    }

    /**
     * Identify a user with Pendo
     */
    identify(visitor: any, account?: any): void {
        if (!this.isPendoReady()) return;

        try {
            const visitorId = String(visitor.id || visitor.email || 'anonymous');
            const accountId = account ? String(account.id) : undefined;

            if (accountId) {
                window.pendo.identify(visitorId, accountId, visitor, account);
            } else {
                window.pendo.identify(visitorId, undefined, visitor);
            }
        } catch (error) {
            console.error('Pendo identify failed:', error);
        }
    }

    /**
     * Trigger a page load event
     */
    pageLoad(options?: any): void {
        if (!this.isPendoReady()) return;

        try {
            window.pendo.pageLoad(options);
        } catch (error) {
            console.error('Pendo pageLoad failed:', error);
        }
    }
}

// Export a singleton instance
export const pendoService = new PendoService();
